import useFeatureFlags from 'common/hooks/useFeatureFlags';
import useUser from 'common/hooks/useUser';

export const useIsListingManagerDevtoolsEnabled = () => {
  const { isEmployee, user } = useUser();

  const {
    data: featureFlags,
    isLoading,
    isFetching,
  } = useFeatureFlags(
    ['enable_listing_manager_developer_tools'],
    {
      user_id: user?.id || '',
    },
    { enabled: isEmployee },
  );

  if (!isEmployee || (isLoading && isFetching)) {
    return false;
  }

  return featureFlags?.enable_listing_manager_developer_tools === 'on';
};
